import React, { useState, useEffect } from 'react';
import axios from '../utils/axiosInstance';
import { jwtDecode } from 'jwt-decode';
import '../styles/Calendar.css';

const Calendar = () => {
  const [events, setEvents] = useState([]);
  const [status, setStatus] = useState('');
  const [filter, setFilter] = useState('all');
  const [userId, setUserId] = useState('');
  const [calendarConnected, setCalendarConnected] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setUserId(decoded.email);
    } catch (err) {
      console.error('Invalid token:', err);
      setStatus('Login error. Please reauthenticate.');
    }
  }, []);

  useEffect(() => {
    if (!userId) return;

    const fetchEvents = async () => {
      try {
        const response = await axios.get(`/api/calendar/events?userId=${userId}`);
        setEvents(response.data.events);
        setCalendarConnected(true);
        setStatus('');
      } catch (error) {
        if (error.response?.status === 404) {
          setCalendarConnected(false);
          setStatus('No calendar connected for this user.');
        } else {
          console.error('API Response Error:', error);
          setStatus('Failed to load events.');
        }
      }
    };

    fetchEvents();
  }, [userId]);

  const handleConnectGoogle = () => {
    if (!userId) return;
    window.location.href = `https://homeleadiq.onrender.com/api/calendar/auth?userId=${userId}`;
  };

  const handleConnectOutlook = () => {
    if (!userId) return;
    window.location.href = `https://homeleadiq.onrender.com/api/outlook/auth?userId=${userId}`;
  };

  const filteredEvents = events.filter((event) => {
    if (filter === 'all') return true;
    return event.summary.toLowerCase().includes(filter.toLowerCase());
  });

  return (
    <div className="calendar-container">
      <h2>My Calendar</h2>

      {!calendarConnected ? (
        <div className="calendar-connect-box">
          <p>{status || 'Connect a calendar to view events.'}</p>
          <div className="calendar-button-group">
            <button className="connect-button" onClick={handleConnectGoogle}>
              Connect Google Calendar
            </button>
            <button className="connect-button" onClick={handleConnectOutlook}>
              Connect Outlook Calendar
            </button>
          </div>
        </div>
      ) : (
  // existing calendar display
        <>
          <div className="calendar-filter">
            <label htmlFor="filter">Filter by Type:</label>
            <select
              id="filter"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Events</option>
              <option value="checkin">Check-ins</option>
              <option value="call">Calls</option>
            </select>
          </div>

          {status && <p className="error-message">{status}</p>}

          {filteredEvents.length > 0 ? (
            <ul className="events-list">
              {filteredEvents.map((event) => (
                <li key={event.id} className="event-card">
                  <strong>{event.summary}</strong>
                  <p>{new Date(event.start.dateTime).toLocaleString()}</p>
                </li>
              ))}
            </ul>
          ) : (
            !status && <p>No events available.</p>
          )}
        </>
      )}
    </div>
  );
};

export default Calendar;